module.exports = __webpack_public_path__ + "img/73.6.CODm.811b80cd.png";